import { takeLatest, put, call, select } from 'redux-saga/effects';
import { GET_GIFTS_ORDERS_SAGA } from "../sagaTypes";
import { loaderAction, giftsOrdersAction, paginationAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";

const request = data => {
    return fetch(`${ url }/get_orders_gifts`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerGetGiftsOrders(args) {
    const user = yield select(state => state.user);

    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        formData.append('establishment', args.data.establishment);
        formData.append('page', args.data.page || 1);
        formData.append('user', args.data.user);
        formData.append('status', args.data.status);

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Сохранение списка заказанных бонусов
            yield put(giftsOrdersAction(response.gifts_orders));
            // Сохранение пагинации
            yield put(paginationAction(response.pagination));
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherGetGiftsOrders() {
    yield takeLatest(GET_GIFTS_ORDERS_SAGA, workerGetGiftsOrders);
}